module.exports = __webpack_public_path__ + "img/trouble-1.a066ee6c.png";